import React from 'react';

interface Section { title: string; content: string | string[]; }

const sections: Section[] = [
  {
    title: '1. Information We Collect',
    content: [
      'Personal Information: When you place an order or create an account, we collect your name, email address, phone number, and shipping address.',
      'Payment Information: All transactions are Cash on Delivery (COD) or bank transfer; we do not store credit card details.',
      'Usage Data: We collect information about how you interact with our website, including pages visited, products viewed, and browser type.',
      'Cookies: We use cookies to enhance your browsing experience, remember your cart, and analyze site traffic.',
    ],
  },
  {
    title: '2. How We Use Your Information',
    content: [
      'To process and fulfill your orders, including pet adoptions and accessory shipments.',
      'To communicate with you about your orders, including order confirmation and delivery status updates.',
      'To send you promotional emails and offers (you may unsubscribe at any time).',
      'To improve our website, products, and customer service.',
      'To comply with legal obligations.',
    ],
  },
  {
    title: '3. Information Sharing',
    content: 'We do not sell, trade, or rent your personal information to third parties. We may share information with trusted service providers (e.g., vet checkers, logistics and delivery partners) who assist us in operating our business, subject to confidentiality agreements.',
  },
  {
    title: '4. Data Security',
    content: 'We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure.',
  },
  {
    title: '5. Cookies Policy',
    content: 'Our website uses cookies to improve functionality and user experience. You can choose to disable cookies through your browser settings, but this may affect some features of our website.',
  },
  {
    title: '6. Your Rights',
    content: [
      'Access: You have the right to request a copy of the personal information we hold about you.',
      'Correction: You may request that we correct any inaccurate or incomplete information.',
      'Deletion: You may request deletion of your personal data, subject to certain legal obligations.',
      'Opt-Out: You can unsubscribe from marketing communications at any time.',
    ],
  },
  {
    title: '7. Third-Party Links',
    content: 'Our website may contain links to third-party websites. We are not responsible for the privacy practices of those sites and encourage you to review their privacy policies.',
  },
  {
    title: '8. Children\'s Privacy',
    content: 'Our services are not directed to individuals under the age of 13. We do not knowingly collect personal information from children.',
  },
  {
    title: '9. Changes to This Policy',
    content: 'We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated revision date. Continued use of our website constitutes acceptance of the revised policy.',
  },
  {
    title: '10. Contact Us',
    content: 'If you have any questions about this Privacy Policy or how we handle your data, please contact Royal Pet Store at 0329 5025172 (Call/WhatsApp) or use our contact form.',
  },
];

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-white">
      <div className="bg-primary text-white py-14 px-4 text-center">
        <p className="text-xs tracking-[0.3em] text-accent uppercase mb-3">Legal</p>
        <h1 className="text-3xl md:text-4xl font-serif font-black">Privacy Policy</h1>
        <p className="text-gray-400 text-sm mt-3">Royal Pet Store — Last updated: 2026</p>
      </div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-14">
        <div className="bg-[#FAF8F5] border border-accent/20 rounded-xl p-5 mb-10">
          <p className="text-sm text-gray-800 leading-relaxed">
            At Royal Pet Store, we are committed to protecting your privacy. This policy explains how we collect, use, and safeguard your personal information when you visit our website or make a purchase.
          </p>
        </div>

        <div className="space-y-8">
          {sections.map(section => (
            <div key={section.title}>
              <h2 className="text-base font-serif font-bold text-gray-900 mb-3 uppercase tracking-wide">{section.title}</h2>
              {Array.isArray(section.content) ? (
                <ul className="space-y-2">
                  {section.content.map((item, i) => (
                    <li key={i} className="flex items-start gap-2 text-sm text-gray-600 leading-relaxed">
                      <span className="text-accent mt-1 flex-shrink-0">•</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-sm text-gray-600 leading-relaxed">{section.content}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
